"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = require("../../openapi");
let RecordOutOfDateError = class RecordOutOfDateError extends Error {
    constructor(recordId) {
        let message = "Record you're trying to update is out of date";
        if (recordId) {
            message = `${message}. Record: ${recordId}`;
        }
        super(message);
    }
};
RecordOutOfDateError = __decorate([
    (0, openapi_1.ClassSchema)({
        description: 'Error thrown by an Accessor when a record is out of date',
    })
], RecordOutOfDateError);
exports.default = RecordOutOfDateError;
